import {Grammar} from "../../system/Grammar";

export class Packet {
  id = ""
  code = ""
  timeStamp = ""
  innerStep = ""
  foreTs = ""
  state = {}
  stateInfo = ""
  history = {}
  foreValue = {}
  foreCurve = {}
  dayAheadCurve = {}
  rollCurve = {}
  K = {}
  Cumulative = {}
  event = ""
  step = ""
  park = {}
  constructor(park,assign) {
    this.id = park.id + Grammar.getRamNumber(8)
    this.code = park.code + Grammar.getRamNumber(24)
    this.timeStamp = assign??new Date().getTime()
    this.step = park.step;
    this.innerStep = park.step;
    this.foreTs = parseInt(this.timeStamp) + parseInt(this.step);
    this.park = park
    this.initParam()
  }

  initParam(){
    this.park.nodes.map(n=>{

      this.state[n.key] = {}
      this.history[n.key] = {}
      this.foreValue[n.key] = {}
      this.foreCurve[n.key] = {}
      this.dayAheadCurve[n.key] = {}
      this.rollCurve[n.key] = {}
      this.K[n.key] = {}
      this.Cumulative[n.key] = {}

      n.transformer && n.transformer.map(t=>{
        this.state[t.key] = {}
        this.history[t.key] = {}
        this.foreValue[t.key] = {}
        this.foreCurve[t.key] = {}
        this.dayAheadCurve[t.key] = {}
        this.rollCurve[t.key] = {}
        this.K[t.key] = {}
        this.Cumulative[t.key] = {}
      })

      n.renewablePower && n.renewablePower.map(r=>{
        this.state[r.key] = {}
        this.history[r.key] = {}
        this.foreValue[r.key] = {}
        this.foreCurve[r.key] = {}
        this.dayAheadCurve[r.key] = {}
        this.rollCurve[r.key] = {}
        this.K[r.key] = {}
        this.Cumulative[r.key] = {}
      })
    })
  }

  setStep(step){
    this.step = step;
    this.foreTs = parseInt(this.timeStamp) + parseInt(this.step);
  }

  getKeyState(key){
    return Object.values(this.state[key])[0].toFixed(2)
  }
}

class Node {
  id = ""
  key = ""
  name = ""
  code = ""
  transformer = []
  renewablePower = []
  constructor(obj) {
    this.id = Grammar.getRamNumber(8)
    this.key = obj["key"]
    this.name = obj["name"]
    this.code = obj["code"]
    obj["transformer"] && obj["transformer"].map(t=>{
      let trans = new Transformer(t)
      this.transformer.push(trans)
    })
    obj["renewablePower"] && obj["renewablePower"].map(r=>{
      let renew = new RenewablePower(r)
      this.renewablePower.push(renew)
    })
  }
}

class Transformer {
  id = ""
  key = ""
  name = ""
  type = ""
  capacity = ""
  unit = ""
  level = ""
  constructor(obj) {
    this.id = Grammar.getRamNumber(8)
    this.key = obj["key"]
    this.name = obj["name"]
    this.type = obj["type"]
    this.capacity = obj["capacity"]
    this.unit = obj["unit"]
    this.level = obj["level"]
  }
}

class RenewablePower {
  id = ""
  key = ""
  name = ""
  type = ""
  capacity = 0
  unit = ""
  inverter = 0
  constructor(obj) {
    this.id = Grammar.getRamNumber(8)
    this.key = obj["key"]
    this.name = obj["name"]
    this.type = obj["type"]
    this.capacity = obj["capacity"]
    this.unit = obj["unit"]
    this.inverter = obj["inverter"]
  }
}

export class Park {
  id = ""
  name = ""
  address = ""
  img = ""
  code = ""
  property = ""
  propertyName = ""
  tCapacity = 0;
  resCapacity = 0;
  nodes = [];
  step = 15*60*1000;
  innerStep = 60*1000;
  constructor(obj,step,innerStep) {
    this.id = Grammar.getRamNumber(8)
    this.name = obj["name"]
    this.code = obj["code"]
    this.address = obj["address"]
    this.img = obj["img"]
    this.property = obj["property"]
    this.propertyName = obj["propertyName"]
    this.setStep(step)
    this.setInnerStep(innerStep)
    obj["nodes"] && obj["nodes"].map( n => this.nodes.push(new Node(n)))
    this.calTCapacity()
    this.calResCapacity()
  }

  calTCapacity(){
    let c = 0
    this.nodes.map(n=>{
      n.transformer.map(t=>{
        c += parseInt(t.capacity)
      })
    })
    this.tCapacity = c.toFixed(1)
  }

  calResCapacity(){
    let ret = 0
    this.nodes.map(n=>{
      n.renewablePower.map(r=>{
        ret += parseFloat(r.capacity)
      })
    })
    this.resCapacity = ret.toFixed(1)
  }

  getName(key){
    let name = ""
    this.nodes.map(n=>{
      if(n.key === key) name = n.name;
      n.transformer.map(t=>{
        if(t.key === key) name = t.name
      })
      n.renewablePower.map(r=>{
        if(r.key === key) name = r.name
      })
    })
    return name;
  }

  setStep(step){
    this.step = step;
  }

  setInnerStep(innerStep){
    this.innerStep = innerStep
  }
}
